<nav class="navbar navbar-expand-lg navbar-light justify-content-center " [ngClass]="{'external-padding': authentication.authenticated === true}">
    <a class="navbar-brand d-none" href="#">Navbar</a>
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
    </button>

    <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav mr-auto">
            <li *ngIf="authentication.authenticated" class="nav-item">
                <a class="nav-link" [routerLink]="['/home']" [ngClass]="{'active': selectedItem === 'home'}"
                    (click)="clickClass('home')">Home <span class="sr-only">(current)</span></a>
                <!-- <li *ngIf="authentication.authenticated"><a [routerLink]="['/home']" class="nav-item opensans-bold-sapphire-18px">Home</a></li> -->
            </li>
            <li class="nav-item dropdown" *ngFor="let mm of authentication.userData?.MainMenus;let index = index">
                <a class="nav-link dropdown-toggle" href="#{{mm.Code}}" id="navbarDropdown" role="button"
                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" (click)="clickClass(mm.Code)"
                    [ngClass]="{'active': selectedItem === mm.Code}">
                    {{mm.Name}}
                </a>
                <!-- <ul *ngFor="let sm of subMenus(mm) ">
                    <li>{{sm.Name}}</li>
                </ul> -->
                <ul class=" dropdown-menu " aria-labelledby="navbarDropdown ">
                    <div *ngFor=" let sm of subMenus(mm) ">
                        <li>
                            <!-- <a class="dropdown-item " (click)="menuClicked(sm) ">{{sm.Name}}</a> -->
                            <a class="dropdown-item" [routerLink]="[pathFromScreenName(sm.ScreenName)]"
                                [queryParams]="queryParamsFromScreenName(sm.ScreenName)" (click)="menuClicked(sm)"><span
                                        class=" menu-shd">{{sm.Name}}</span></a>
                        </li>
                    </div>
                    <li *ngIf="mm.Code=='ADMIN'">
                        <a class="dropdown-item" href="javascript:void(0);" (click)="navAuthWeb()"><span class="menu-shd">Auth-Web</span></a>
                    </li>
                    <li *ngIf="mm.Code=='BO'">
                        <a class="dropdown-item" href="javascript:void(0);" (click)="navWFDashboard()"><span class="menu-shd">Workflow Permits</span></a>
                    </li>
                    <li *ngIf="mm.Code=='BO'">
                        <a class="dropdown-item" href="javascript:void(0);" (click)="navSharePoint()"><span class="menu-shd">Workflow Carriers</span></a>
                    </li>
                    <li *ngIf="mm.Code=='RE'">
                        <a class="dropdown-item" href="javascript:void(0);" (click)="subReport()"><span class="menu-shd">Reports</span></a>
                    </li>
                    <li *ngIf="mm.Code=='RE'">
                        <a class="dropdown-item" href="javascript:void(0);" (click)="subPowerBI()"><span class="menu-shd">Power BI</span></a>
                    </li>
                    <!-- <a class="dropdown-item " href="# ">Another action</a>
                    <div class="dropdown-divider "></div>
                    <a class="dropdown-item " href="# ">Something else here</a> -->
                </ul>
            </li>
            <!-- <li class="nav-item ">
                <a class="nav-link disabled " href="# ">Disabled</a>
            </li> -->
        </ul>
        <!-- <form class="form-inline my-2 my-lg-0 ">
            <input class="form-control mr-sm-2 " type="search " placeholder="Search " aria-label="Search ">
            <button class="btn btn-outline-success my-2 my-sm-0 " type="submit ">Search</button>
        </form> -->
    </div>
</nav>
<!-- <div> -->
<!-- <ul class="nav nav-pills justify-content-center ">
        <li *ngIf="authentication.authenticated "><a [routerLink]="[ ' /home '] " class="nav-item opensans-bold-sapphire-18px ">Home</a></li>
        <li class="nav-item dropdown " *ngFor="let mm of authentication.userData?.MainMenus ">
            <a class="nav-link dropdown-toggle opensans-normal-black-18px " data-toggle="dropdown " href="#{{mm.Code}} " role="button " aria-haspopup="true " aria-expanded="false ">{{mm.Name}}</a>

            <div class="dropdown-menu " aria-labelledby="navbarDropdown " *ngFor=" let sm of subMenus(mm) ">
                <a class="dropdown-item " (click)="menuClicked(sm) ">{{sm.Name}}</a>

            </div>

        </li> -->
<!-- <li class="nav-item dropdown " *ngFor="let mm of authentication.userData?.MainMenus " [style.display]="authentication.authenticated && subMenus(mm).length ? 'block ' : 'none ' ">
            <a href="#{{mm.Code}} " data-toggle="dropdown " aria-expanded="false " class="nav-link dropdown-toggle " aria-haspopup="true " aria-expanded="false ">{{mm.Name}}<span class="opensans-normal-black-18px "></span></a>
            <ul class="collapse list-unstyled " id="{{mm.Code}} ">
                <li *ngIf="mm.Code=='ADMIN ' ">
                    <a class="inner " href="javascript:void(0); " (click)="navAuthWeb() "><i class="fa fa-play " aria-hidden="true ">&nbsp;<span class="menu-shd ">Auth-Web</span></i></a>
                </li>
                <li *ngIf="mm.Code=='BO ' ">
                    <a class="inner " href="javascript:void(0); " (click)="navWFDashboard() "><i class="fa fa-play " aria-hidden="true ">&nbsp;<span class="menu-shd ">Workflow Permits</span></i></a>
                </li>
                <li *ngIf="mm.Code=='BO ' ">
                    <a class="inner " href="javascript:void(0); " (click)="navSharePoint() "><i class="fa fa-play "  aria-hidden="true ">&nbsp;<span class="menu-shd ">Workflow Carriers</span></i></a>
                </li>
                <li *ngIf="mm.Code=='RE ' ">
                    <a class="inner " href="javascript:void(0); " (click)="subReport() "><i class="fa fa-play "  aria-hidden="true ">&nbsp;<span class="menu-shd ">Reports</span></i></a>
                </li>
                <li *ngFor="let sm of subMenus(mm) ">
                    <a class="inner menu-shd opensans-normal-black-18px " [routerLink]="[pathFromScreenName(sm.ScreenName)] " 
                    [queryParams]="queryParamsFromScreenName(sm.ScreenName) " (click)="menuClicked(sm) "><i class="fa fa-play " aria-hidden="true ">&nbsp;<span class=" menu-shd ">{{sm.Name}}</span></i></a>
                </li>
            </ul>
        </li> -->
<!-- </ul> -->


<!-- </div> -->